import React from 'react'
import styled from 'styled-components'
import { media, fonts } from '../utils/style-utils'

const NumberWrapper = styled.div`
  font-family: ${fonts.special};
  letter-spacing: 0.08em;
  line-height: 1.2;
  white-space: nowrap;
  font-size: 2rem;

  ${media.tablet`
  font-size: 3rem;
  `} ${media.desktop`
  font-size: 8rem;
  `};
`

const FancyNumber = props => {
  const { children, className } = props
  return <NumberWrapper className={className}>{children}—</NumberWrapper>
}

export default FancyNumber



// WEBPACK FOOTER //
// ./src/components/FancyNumber.js